import './style.css';


export default class TalkToUsFlybtn {

  static selector = '.talk-to-us_fly-btn';

  constructor(block) {
    this.block = block;
    this.talkUsBanner = document.querySelector('.talk-us-banner__button');
  }

  hideFlyBtn = () => {

    if (!this.talkUsBanner) { return; }
    const talkUsBannerRect = this.talkUsBanner.getBoundingClientRect();
    const isInViewport = talkUsBannerRect.top >= 0 && talkUsBannerRect.bottom <= window.innerHeight;

    if (isInViewport) {
      this.block.classList.add('hidden');
    }
    else {
      this.block.classList.remove('hidden');
    }

  };



  onScroll = () => {
    this.hideFlyBtn();
  }



}
